import { ArrowLeftOutlined } from '@ant-design/icons'

export default function PageTitle(props) {

	function onClick() {
		window.history.back()
	}

	return <div style={{
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		margin: "15px 26px 0 39px",
		color: '#fff',
		...(props.style || {})
	}}>
		<div style={{fontSize: '20px', fontWeight: 'bold'}}>{props.title}</div>
		<div onClick={() => onClick()} style={{
			width: '108px',
			height: '36px',
			padding: '0 10px',
			border: '1px solid #fff',
			borderRadius: '24px',
			display: 'flex',
			justifyContent:'center',
			alignItems: 'center',
			background: 'rgba(0,0,0,.3)',
			cursor: "pointer",
		}}>
			<ArrowLeftOutlined style={{ fontSize: "18px", marginRight: '10px'}} />
			<span style={{ fontSize: "16px" }}>返回</span>
		</div>
	</div>
}
